import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Connects to data-controller="bridge--share-button"
// Sends PDF URL and title to native share sheet component.
export default class extends BridgeComponent {
  static component = "share-button"

  connect() {
    super.connect()

    const title = this.bridgeElement.bridgeAttribute("title")
    const pdfUrl = this.bridgeElement.bridgeAttribute("pdf-url")
    const filename = this.bridgeElement.bridgeAttribute("filename")
    const imageName = this.bridgeElement.bridgeAttribute("ios-image-name")
    const iconName = this.bridgeElement.bridgeAttribute("android-icon-name")

    this.send(
      "connect",
      { title, pdfUrl, filename, imageName, iconName },
      () => {
        // No reply expected from native; share sheet is fire-and-forget.
      },
    )
  }
}
